<template>
  <div style="width: 100%;">
    <el-empty :image-size="100" v-if="equipList.length === 0"></el-empty>
    <el-row v-else :gutter="20" style="width: 100%;">
      <el-col :span="8" v-for="(value, key) in equipList" :key="key">
        <div class="grid-content" style="width:100%">
          <el-image class="content-img" style="width: 100px; height: 100px" :src="value.image" fit="scale-down"
            alt="设备图片"></el-image>
          <div class="content">
            <div class="content-title">{{ value.name }}</div>
            <div class="content-serial">{{ value.serial }}</div>
            <div class="content-place">
              <div class="place-label">{{ value.hall }}</div>
              <div class="place-status" v-if="value.online === 1">正常</div>
              <div class="place-status-error" v-if="value.online === 0">断线</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getList } from "@/api/product.js"
export default {
  props: {
    temple: {
      type: Number,
      default: 0
    },
    hall: {
      type: Number,
      default: 0
    },
    building: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      equipList: [],
      form: {
        page: 1,
        count: 9,
        temple_id: 0,
        hall_id: 0,
        building_id: 0,
        keyword: ''
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.temple !== 0) {
        this.form.temple_id = this.temple
      }
      if (this.hall !== 0) {
        this.form.hall_id = this.hall
      }
      if (this.building !== 0) {
        this.form.building_id = this.building
      }
      getList(this.form).then(res => {
        if (res.code === 200) {
          this.equipList = res.data.data
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  width: 100%;
  box-sizing: border-box;
  margin: 0 !important;
  padding-bottom: 20px;
}

.el-col {
  // margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
  border-radius: 10px;
  box-sizing: border-box;
  padding: 10px;

  .content-img {
    width: 100%;
    height: 100%;
  }

  .content {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 10px;

    .content-title {
      font-weight: 600;
      font-size: 18px;
    }

    .content-place {
      font-weight: 400;
      display: flex;
      justify-content: space-between;
      width: 100%;

      .place-label {
        color: #666666;
      }

      .place-status {
        font-size: 14px;
        width: 50px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 5px;
        background-color: #0ec79f;
        color: #067960;
      }

      .place-status-error {
        font-size: 14px;
        width: 70px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 5px;
        background-color: #dbdbdb;
        color: #666;
      }
    }
  }
}
</style>